import React from 'react'
import * as Effects from 'redux-saga/effects'
import { requestSynchronization } from '../../actions/synchronize/synchronize'
import RoomLimitsExceededModal from '../../containers/BookingCalendar/RoomLimitsExceededModal'
import { Modals } from '../../containers/Modals/ModalContainer'
import openModal from '../../actions/Modals/openModal'
import { SynchronizeActions } from '../../reducers/synchronize/actionNames'
import { isAtMaxRooms } from '../../reducers/userAccount/selectors/roomLimit'

export default function*() {
  yield Effects.put(requestSynchronization())
  yield Effects.take(SynchronizeActions.SyncCompleted)
  const isAtRoomLimit = yield Effects.select(isAtMaxRooms)
  if (isAtRoomLimit) {
    yield Effects.put(openModal(Modals.AddRoom, <RoomLimitsExceededModal />))
    throw new Error('Room limit reached')
  }
}
